export const LIVE_COLORS = {
  bg: 'var(--c-bg)', surface: 'var(--c-surface)', card: 'var(--c-card)', border: 'var(--c-border)',
  white: 'var(--c-text)', gray: 'var(--c-text-muted)', muted: 'var(--c-text-dim)',
  accent: 'var(--c-accent)', accentDim: 'var(--c-accent-dim)', accentWarm: 'var(--c-accent-warm)',
  green: 'var(--c-green)', red: 'var(--c-red)', amber: 'var(--c-amber)', blue: 'var(--c-blue)',
  yellow: 'var(--c-yellow)',
} as const;

export function cA(color: string, hexAlpha: string): string {
  const pct = Math.round((parseInt(hexAlpha, 16) / 255) * 100);
  return `color-mix(in srgb, ${color} ${pct}%, transparent)`;
}

export type Sev = 'red' | 'yellow' | 'blue' | 'green';
export const SEV_COLORS: Record<Sev, string> = {
  red: LIVE_COLORS.red, yellow: LIVE_COLORS.yellow,
  blue: LIVE_COLORS.blue, green: LIVE_COLORS.green,
};

export const MD_CHIP_COLORS: Record<string, string> = {
  'MD-6': '#22c55e', 'MD-5': '#22c55e',
  'MD-4': '#22c55e', 'MD-3': '#22c55e', 'MD-2': '#84cc16',
  'MD-1': '#eab308', 'MD': '#ef4444', 'Matchday': '#ef4444',
  'MD+1': '#06b6d4', 'MD+2': '#06b6d4',
  'MD+3': '#06b6d4', 'MD+4': '#06b6d4', 'MD+5': '#06b6d4', 'MD+6': '#06b6d4',
  'Off-Season': '#8b5cf6',
};

export type RuleCatKey = 'universal' | 'wellness' | 'injury' | 'formation'
  | 'goalkeeper' | 'striker' | 'defender' | 'midfielder';
export interface RuleCatInfo { name: string; color: string; bg: string; border: string; }
export const RULE_CATS: Record<RuleCatKey, RuleCatInfo> = {
  universal:  { name: 'Universal',   color: '#2dd4bf', bg: 'rgba(45,212,191,0.06)',  border: 'rgba(45,212,191,0.15)' },
  wellness:   { name: 'Wellness',    color: '#a855f7', bg: 'rgba(168,85,247,0.06)',  border: 'rgba(168,85,247,0.15)' },
  injury:     { name: 'Injury',      color: '#f97316', bg: 'rgba(249,115,22,0.06)',  border: 'rgba(249,115,22,0.15)' },
  formation:  { name: 'Formation',   color: '#6366f1', bg: 'rgba(99,102,241,0.06)',  border: 'rgba(99,102,241,0.15)' },
  goalkeeper: { name: 'Goalkeeper',  color: '#f59e0b', bg: 'rgba(245,158,11,0.06)',  border: 'rgba(245,158,11,0.15)' },
  striker:    { name: 'Striker',     color: '#ef4444', bg: 'rgba(239,68,68,0.06)',   border: 'rgba(239,68,68,0.15)' },
  defender:   { name: 'Defender',    color: '#06b6d4', bg: 'rgba(6,182,212,0.06)',   border: 'rgba(6,182,212,0.15)' },
  midfielder: { name: 'Midfielder',  color: '#8b5cf6', bg: 'rgba(139,92,246,0.06)',  border: 'rgba(139,92,246,0.15)' },
};
